// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1Ga94","messages":"Chat_messages__9fTAJ","dateDivider":"Chat_dateDivider__1eYoH"};